import { createAction } from '@reduxjs/toolkit';

export const getPackage = {
    request: createAction('package/get/request'),
    success: createAction('package/get/success'),
    failed: createAction('package/get/failed'),
};

export const getPackageById = {
    request: createAction('package/getById/request'),
    success: createAction('package/getById/success'),
    failed: createAction('package/getById/failed'),
};

export const createPackage = {
    request: createAction('package/create/request'),
    success: createAction('package/create/success'),
    failed: createAction('package/create/failed'),
};

export const updatePackage = {
    request: createAction('package/update/request'),
    success: createAction('package/update/success'),
    failed: createAction('package/update/failed'),
};

export const deletePackage = {
    request: createAction('package/delete/request'),
    success: createAction('package/delete/success'),
    failed: createAction('package/delete/failed'),
};

export const getPublicPackage = {
    request: createAction('package/getPublic/request'),
    success: createAction('package/getPublic/success'),
    failed: createAction('package/getPublic/failed'),
};
